import { render, staticRenderFns } from "./step_5.vue?vue&type=template&id=67cba4ed&"
import script from "./step_5.vue?vue&type=script&lang=js&"
export * from "./step_5.vue?vue&type=script&lang=js&"
import style0 from "./step_5.vue?vue&type=style&index=0&id=67cba4ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports